Drupal.behaviors.tableresponsive = {
  attach() {
    var table = document.querySelectorAll(".right-side-content table"); 
    table.forEach((tbl) => {
      var wrapper = document.createElement('div');
      tbl.parentNode.insertBefore(wrapper, tbl);
      wrapper.appendChild(tbl);
      wrapper.classList.add('responsive_table');
    });
  },
};
